var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _g4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _circle, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAILogo = function SvgAILogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61.515,
    height: 47.556
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m14.605 37.972-2.992 9.547H0L16.6 0h13.322l15.1 47.519H32.914l-2.565-9.547Zm8.407-27.357-5.77 18.594H28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h11.431v47.519H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m23.011 10.615 4.987 18.594H17.242ZM16.599 0l-16.6 47.519h11.614l2.992-9.547H30.35l2.565 9.547h12.111L29.926 0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.269v16.699H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.324v29.463H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.785v1.785H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.443v12.856H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.785v10.967H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.589v.214H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.38v1.353H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.89v1.853H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.031v4.57H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.165v5.165H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h4.57v1.031H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.441v.441H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.306v4.153H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.306v.306H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.306v.307H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__z"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m.562.255.177.461H.387ZM.462 0 .003 1.182h.2l.108-.28h.5l.108.28h.2L.66 0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.203v1.182H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__C"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.777.514A5.34 5.34 0 0 0 1.035 6.15a10.4 10.4 0 0 1 .2 2.054C1.228 8.76-.416 10.776.109 11.03l.014.007c.5.2 1.208.19 1.435.467a.3.3 0 0 1 .05.184c.006.266-.222.748-.221 1.055a.23.23 0 0 0 .051.148c.184.235.9.134 1.01.122h.018s-.508.185-.654.269a.4.4 0 0 0-.1.281.5.5 0 0 0 .092.241c.136.2.292.383.289.555v.037c0 .029 0 .063-.009.1-.04.445-.174 1.5.36 1.827.6.367 5.182-.676 5.591-1.336a19 19 0 0 0 1.5-3.06 1.09 1.09 0 0 0-.46-1.347 4.25 4.25 0 0 1-2.1-3.7 4.3 4.3 0 0 1 3.349-4.1V.314A12.5 12.5 0 0 0 7.656.003a7.6 7.6 0 0 0-2.87.513"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__D"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.001 3.202a3.38 3.38 0 0 0 2.418 3.283V0A3.38 3.38 0 0 0 .001 3.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__F"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1.253 1.071A4.158 4.158 0 0 0 3.194 8.09v-.078A4.09 4.09 0 0 1 .076 3.997 4.09 4.09 0 0 1 3.194.077v-.078A4.13 4.13 0 0 0 1.253 1.07"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h.775v.857H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__I"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.674v.735H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__J"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.412v2.885H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__K"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.129v2.004H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__L"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.628v.187H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI_logo_svg__M"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.049 8.773s-.742 3.788 3.576 1.745V0C.579 3.473.049 8.773.049 8.773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI_logo_svg__d",
    x1: 0.094,
    x2: 0.094,
    y1: 1.441,
    y2: 1.441,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c8efa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8386f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#9973dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#bd53bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf44ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI_logo_svg__f",
    x1: -0.752,
    x2: -0.751,
    y1: 2.306,
    y2: 2.306,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c8efa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#7f8af6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#8b80eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#9f6ed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#ba56be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf44ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI_logo_svg__a",
    x1: -25.976,
    x2: -25.949,
    y1: 35.987,
    y2: 35.987,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c8efa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#8544ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#8742ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ab2aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#c617e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#da0af1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#e602fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea00ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#aI_logo_svg__a",
    id: "aI_logo_svg__B",
    x1: -72.968,
    x2: -72.895,
    y1: 43.467,
    y2: 43.467
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI_logo_svg__b",
    x1: -2.982,
    x2: -2.979,
    y1: 6.563,
    y2: 6.563,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#efedff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#c7bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#bcb3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcb3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#aI_logo_svg__b",
    id: "aI_logo_svg__E",
    x1: -8.65,
    x2: -8.645,
    y1: 15.535,
    y2: 15.535
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#aI_logo_svg__b",
    id: "aI_logo_svg__G",
    x1: -6.735,
    x2: -6.731,
    y1: 12.216,
    y2: 12.216
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#aI_logo_svg__b",
    id: "aI_logo_svg__N",
    x1: -7.84,
    x2: -7.835,
    y1: 4.025,
    y2: 4.025
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aI_logo_svg__y",
    cx: 0.5,
    cy: 0.5,
    r: 0.686,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d044ab",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__c)",
    transform: "translate(0 .038)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__d)",
    d: "M0 0h62.998v63.865H0z",
    transform: "rotate(-30.772 12.157 44.174)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__e)",
    transform: "translate(50.084 .038)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__f)",
    d: "M0 0h11.431v47.519H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.531h11.431v47.519H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__g)",
    transform: "translate(0 .038)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__h)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(15.972 31.905)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.213 16.7H.004V4.6L3.06 1.544V0h.214v1.632L.218 4.688Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__i)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(30.401 -.804)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11 27.782h.214v.56H3.11zM3.11 28.902h.214v.56H3.11zM3.11 24.421h.214v.56H3.11zM3.11 25.541h.214v.56H3.11zM3.11 26.662h.214v.56H3.11zM3.324 23.861H3.11v-.225l-.155-.151.143-.171.225.22ZM2.565 23.105l-.39-.38.143-.171.39.38Zm-.78-.761-.39-.38.143-.171.39.38Zm-.78-.761-.39-.38.143-.171.39.38ZM.225 20.822 0 20.602v-.327h.214v.225l.155.151ZM0 18.035h.214v.56H0zM0 19.155h.214v.56H0zM0 16.915h.214v.56H0zM0 13.555h.214v.56H0zM0 15.795h.214v.56H0zM0 14.675h.214v.56H0zM0 11.121h.214v.56H0zM0 12.241h.214v.56H0zM0 10.001h.214v.56H0zM0 6.641h.214v.56H0zM0 8.881h.214v.56H0zM0 7.761h.214v.56H0zM0 4.48h.214v.56H0zM0 5.6h.214v.56H0zM0 3.36h.214v.56H0zM0 2.24h.214v.56H0zM0 1.12h.214v.56H0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.416 49.101h-.214c.014-2.556.014-5.159 0-7.737h.214c.014 2.579.014 5.183 0 7.74M30.87 32.662v.322c-2.627-.005-5.815-.005-8.391-.005a92 92 0 0 0-2.273 2.261c-.376.383-.766.78-1.152 1.167l-.047.047h-22.09v-.322h21.956c.37-.371.742-.75 1.1-1.117.753-.767 1.532-1.561 2.328-2.314l.047-.044h.069c2.587 0 5.806 0 8.455.005M35.599 29.167h-.232v-6.858L33.2 19.926V-4.567l-4.767-3.857v-15.327h.641v15.038l4.363 3.857v24.71l2.167 2.383Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__j)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(18.431 29.729)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.892 1.785a.892.892 0 1 1 .892-.892.893.893 0 0 1-.892.892m0-1.571a.679.679 0 1 0 .679.679.68.68 0 0 0-.679-.679"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.062 40.16h.214v16.389h-.214z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.092 40.362a.892.892 0 1 1 .892-.892.893.893 0 0 1-.892.892m0-1.571a.679.679 0 1 0 .679.679.68.68 0 0 0-.679-.679M36.477 12.314a.892.892 0 1 1 .892-.892.893.893 0 0 1-.892.892m0-1.571a.679.679 0 1 0 .679.679.68.68 0 0 0-.679-.679M30.895 31.981H13.973v-.214h16.922Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.048 31.861a.892.892 0 1 1-.892-.892.893.893 0 0 1 .892.892m-1.571 0a.679.679 0 1 0 .679-.679.68.68 0 0 0-.679.679M35.598 36.089v17.473h-.214V36.089ZM36.37 12.248h.214v9.248h-.214z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#aI_logo_svg__k)",
    opacity: 0.6,
    transform: "translate(26.082 -1.072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08 9.995v-10h.246V9.99ZM1.22 12.857a1.221 1.221 0 1 1 1.222-1.22 1.223 1.223 0 0 1-1.222 1.22m0-1.735a.514.514 0 1 0 .513.514.514.514 0 0 0-.513-.514"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#aI_logo_svg__l)",
    opacity: 0.6,
    transform: "translate(20.552 -2.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.892 9.182a.892.892 0 1 1-.892.892.893.893 0 0 1 .892-.892m0 1.571a.679.679 0 1 0-.679-.679.68.68 0 0 0 .679.679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.839 0h.214v9.248H.839z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.477 9.468a.892.892 0 1 1 .892-.892.893.893 0 0 1-.892.892m0-1.571a.679.679 0 1 0 .679.679.68.68 0 0 0-.679-.679"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a59b0",
    d: "M36.582 7.75h-.214v-.037h.214Zm0-.55h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.026h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214V.536h.214Zm0-1.026h-.214V-.49h.214Zm0-1.025h-.214v-.513h.214Zm0-1.026h-.214v-.513h.214ZM19.22 9.956h-.214v-.037h.214Zm0-.55h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.026h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.026h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.026h-.214V.69h.214Zm0-1.025h-.214v-.513h.214Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a59b0",
    d: "M19.22 19.184h-.214v-.037h.214Zm0-.55h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.026h-.214v-.513h.214Zm0-1.026h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214Zm0-1.025h-.214v-.513h.214ZM19.006 21.149h.214v.513h-.214zM19.006 20.123h.214v.513h-.214z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a59b0",
    d: "M19.006 19.098h.214v.513h-.214zM19.006 23.2h.214v.513h-.214zM19.006 22.174h.214v.513h-.214zM19.006 24.225h.214v.513h-.214zM7.019 39.199H6.74v-.033h.279Zm0-.554H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a59b0",
    d: "M7.019 48.488H6.74v-.038h.279Zm0-.554H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Zm0-1.032H6.74v-.516h.279Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.071 35.677a.785.785 0 1 1-.786-.785.785.785 0 0 1 .786.785"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.287 37.376a1.7 1.7 0 1 1 1.7-1.7 1.7 1.7 0 0 1-1.7 1.7m0-3.182a1.484 1.484 0 1 0 1.484 1.484 1.486 1.486 0 0 0-1.484-1.484"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d2ff",
    d: "M27.566 20.694v-5.331l2.863-3.247c0-.784 0-9.455-.012-15.382h.214c.012 6.1.012 15.3.012 15.423v.04l-2.863 3.247v5.251Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d2ff",
    d: "M27.686 22.393a.892.892 0 1 1 .892-.892.893.893 0 0 1-.892.892m0-1.571a.679.679 0 1 0 .679.679.68.68 0 0 0-.679-.679"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d2ff",
    d: "M28.13 21.5a.443.443 0 1 1-.443-.443.443.443 0 0 1 .443.443"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.867 11.429a.382.382 0 1 1-.382-.382.38.38 0 0 1 .382.382M31.536 24.929a.892.892 0 1 1 .892-.892.893.893 0 0 1-.892.892m0-1.571a.679.679 0 1 0 .679.679.68.68 0 0 0-.679-.679"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.938 24.037a.4.4 0 1 1-.4-.4.4.4 0 0 1 .4.4M37.923 36.164h-7.089v-7.1h7.093Zm-6.872-.221h6.651v-6.651h-6.651Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.923 36.164h-7.089v-7.1h7.093Zm-6.872-.221h6.651v-6.651h-6.651Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.152 35.391h-5.551V29.84h5.551Zm-5.33-.221h5.107v-5.111H31.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__m)",
    opacity: 0.4,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.538 35.396)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.051 0h.513v.214h-.513zM1.025 0h.513v.214h-.513zM0 0h.513v.214H0zM3.076 0h.513v.214h-.513z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__n)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(29.794 28.061)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.472 1.354H.004V0h1.38v.468H.472Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__n)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(28.818 27.057)"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.469 1.354H.001V0h1.38v.468H.469Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__o)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(37.347 35.583)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.89 1.853H0v-.641h1.249V0h.641Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__o)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(38.505 36.741)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.89 1.852H0v-.641h1.249V-.001h.641Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a59b0",
    d: "m34.622 19.726 5.443-6.531.164.137-5.443 6.531zM40.78-3.142h.214v14.787h-.214z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.161 12.562a.382.382 0 1 1-.382-.382.38.38 0 0 1 .382.382"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#aI_logo_svg__p)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(36.202 23.781)"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m1.032.703-.516-.7-.516.7ZM1.032 1.669l-.516-.7-.516.7ZM1.032 2.637l-.516-.7-.516.7ZM1.032 3.604l-.516-.7-.516.7ZM1.032 4.57l-.516-.7-.516.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#aI_logo_svg__q)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(8.924 41.392)"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m0 4.371.583.794.583-.794ZM0 3.278l.583.794.583-.794ZM0 2.185l.583.794.583-.794ZM0 1.088l.583.794.583-.794ZM0 0l.583.794L1.166 0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#aI_logo_svg__r)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(24.848 30.085)"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m.703 0-.7.516.7.515ZM1.67 0l-.7.516.7.515ZM2.636 0l-.7.516.7.515ZM3.604 0l-.7.516.7.515ZM4.57 0l-.7.516.7.515Z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.571 41.593h.233v5.923h-.233zM38.454 40.464h-4.928v-4.391h.233v4.158h4.7ZM39.631 41.378a.874.874 0 1 1 .874-.875.876.876 0 0 1-.874.875m0-1.54a.665.665 0 1 0 .665.665.666.666 0 0 0-.665-.665"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.025 40.503a.394.394 0 1 1-.394-.394.394.394 0 0 1 .394.394M25.933 23.705h4.251v.233h-4.251zM31.638 25.342h.233v3.87h-.233zM19.736 30.601a.4.4 0 1 1-.4-.4.4.4 0 0 1 .4.4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__s)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(23.808 30.381)"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M.441.22A.22.22 0 1 1 .22 0a.22.22 0 0 1 .221.22"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__s)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(23.038 30.381)"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M.441.22A.22.22 0 1 1 .221 0a.22.22 0 0 1 .22.22"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__s)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(22.268 30.381)"
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M.441.22A.22.22 0 1 1 .221 0a.22.22 0 0 1 .22.22"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__s)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(21.499 30.381)"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M.441.22A.22.22 0 1 1 .221 0a.22.22 0 0 1 .22.22"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__t)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    transform: "translate(38.815 42.398)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(0 1.603)"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(0 1.069)"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(0 .534)"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(0 3.847)"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(0 3.313)"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(0 2.778)"
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__v)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(0 2.243)"
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.153.306A.153.153 0 1 1 .306.153a.153.153 0 0 1-.153.153"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 5.423)"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 4.888)"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 4.354)"
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__v)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 3.819)"
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 7.666)"
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__v)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 7.132)"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__v)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 6.597)"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 6.063)"
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 17.309)"
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 16.774)"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 16.24)"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 15.705)"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.304A.153.153 0 1 1 .311.151a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 19.552)"
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 19.018)"
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__u)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 18.484)"
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__v)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(26.071 17.949)"
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.158.306A.153.153 0 1 1 .311.153a.153.153 0 0 1-.153.153"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.604 36.417-2.566-2.566h-7.6v-.28h7.714l2.648 2.648ZM32.774 31.013h3.206v3.206h-3.206z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.087 31.591h-.659a.118.118 0 1 1 0-.235h.659a.118.118 0 0 1 0 .235M33.087 32.266h-.659a.118.118 0 1 1 0-.235h.659a.118.118 0 1 1 0 .235M33.087 32.94h-.659a.118.118 0 0 1 0-.235h.659a.118.118 0 0 1 0 .235M33.087 33.615h-.659a.118.118 0 1 1 0-.235h.659a.118.118 0 1 1 0 .235M36.325 31.591h-.659a.118.118 0 0 1 0-.235h.659a.118.118 0 1 1 0 .235M36.325 32.266h-.659a.118.118 0 1 1 0-.235h.659a.118.118 0 1 1 0 .235M36.325 32.94h-.659a.118.118 0 0 1 0-.235h.659a.118.118 0 1 1 0 .235M36.325 33.615h-.659a.118.118 0 1 1 0-.235h.659a.118.118 0 1 1 0 .235M35.285 31.238v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0M34.61 31.238v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0M33.935 31.238v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0M33.261 31.238v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0M35.285 34.49v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0M34.61 34.49v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0M33.935 34.49v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0M33.261 34.49v-.66a.118.118 0 0 1 .235 0v.66a.118.118 0 0 1-.235 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "url(#aI_logo_svg__y)",
    transform: "translate(17.107 28.469)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__z)",
    transform: "translate(33.521 32.062)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__a)",
    d: "M0 0h1.404v1.443H0z",
    transform: "rotate(-15.85 .161 1.158)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__A)",
    transform: "translate(34.804 32.062)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__B)",
    d: "M0 0h.517v1.192H0z",
    transform: "rotate(-15.824 .162 1.16)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.838 29.197h-3.777v-3.774h3.777Zm-3.659-.118h3.542v-3.542h-3.542Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "url(#aI_logo_svg__y)",
    transform: "translate(22.513 33.469)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.428 28.785h-2.956v-2.956h2.956Zm-2.838-.118h2.72v-2.72h-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.096 26.455h1.707v1.707h-1.707zM5.207 26.345h6.861v.106H5.207zM5.207 27.003h6.861v.106H5.207zM5.207 27.661h6.861v.106H5.207zM5.207 28.319h6.861v.106H5.207zM14.806 25.458h-.083v-4.691l.013-.013 2.177-2.177c.034-6.732.079-19.506 0-19.792a.04.04 0 0 0 .028.026l.011-.041-.032-.032.049-.01c.037.015.044.018.055.9.006.517.011 1.274.013 2.252 0 1.646 0 3.939-.005 6.814-.013 4.895-.038 9.848-.038 9.9v.018l-.013.013-2.177 2.177Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.151 25.457h-.087v-8.751l1.228-1.172V1.586h.087v13.986l-1.228 1.172ZM13.491 25.457h-.087v-6.469l-1.332-1.67V2.336h.087v14.952l1.333 1.671Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.832 25.458h-.087l.044-3.479-1.784-1.784V14.36h.087v5.8l1.784 1.784v.018Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "url(#aI_logo_svg__y)",
    transform: "translate(25.513 8.469)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__e)",
    transform: "translate(50.084 .038)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#352d57",
    d: "M9.269 41.127c.1.286 7.042 13.771 7.042 13.771V33.511Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e1930",
    d: "M10.719 32.251a45.5 45.5 0 0 0-1.961-11.693l.384-.125a46 46 0 0 1 1.981 11.814ZM16.329 18l-4.388 4.987-1.224-4.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e1930",
    d: "M6.752 14.236a5.579 5.579 0 1 0 5.645-5.512 5.58 5.58 0 0 0-5.645 5.512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e1930",
    d: "m10.342 19.479 2.193-.603 3.042 11.07-2.192.602z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#352d57",
    d: "M10.049 22.333 9.675 21l3.482-1.183.481 1.716ZM10.598 24.347l-.374-1.333 3.482-1.183.481 1.716ZM11.148 26.363l-.374-1.333 3.482-1.183.481 1.716ZM11.696 28.378l-.374-1.333 3.482-1.183.481 1.716Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__C)",
    transform: "translate(51.2 7.36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__b)",
    d: "M0 0h17.012v11.243H0z",
    transform: "matrix(.031 -1 1 .031 -.934 16.674)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__D)",
    transform: "translate(59.097 11.035)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__E)",
    d: "M0 0h6.926v4.629H0z",
    transform: "rotate(-68.654 3.01 4.436)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__F)",
    transform: "translate(58.321 10.231)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__G)",
    d: "M0 0h8.706v5.941H0z",
    transform: "rotate(-68.654 3.756 5.534)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__e)",
    transform: "translate(50.084 .038)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__H)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(2.917 20.961)"
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#171516",
    d: "M.288.755c0 .029 0 .063-.009.1A1.54 1.54 0 0 0 .774.062C.753-.101.279.089 0 .162c.136.2.292.384.289.556v.037"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__I)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(1.22 18.274)"
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#171516",
    d: "m0 .077.014.007c.5.2 1.208.19 1.435.467a.3.3 0 0 1 .05.184c.1-.169.25-.482.131-.649C1.485-.12.53.119-.001.078"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__J)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(4.906 15.396)"
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.289.327A2.9 2.9 0 0 0 1.068 0C.348-.033-.019 2.542.001 2.854S3.051.936 2.289.326"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__K)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(2.579 13.868)"
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#171516",
    d: "M1.677 1.73s.58-.381.426-.771A2.88 2.88 0 0 0 .173.016c-.361.125-.09 1.673.208 1.886.428.307 1.3-.172 1.3-.172"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#171516",
    d: "M3.051 15.526a1 1 0 0 0 .044.091s1.366-.354 1.374-.59-1.356-.678-1.356-.678a.6.6 0 0 0-.078.145 1.5 1.5 0 0 0 .016 1.032"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#171516",
    d: "M3.658 14.538s-.7-.289-.749-.216.15.28.4.389c.522.228.629-.015.35-.173"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#846fd9",
    d: "M3.051 15.527c.18-.02.324-.241.328-.511 0-.286-.15-.519-.344-.521a1.5 1.5 0 0 0 .016 1.032"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.995 15.356c.118-.013.212-.158.214-.335s-.1-.34-.225-.341a.63.63 0 0 0 .01.676"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__L)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    },
    transform: "translate(2.549 20.178)"
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#171516",
    d: "M.003.029c.184.235.9.134 1.009.123a5 5 0 0 1 .619-.156A5.7 5.7 0 0 1 .003.029"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI_logo_svg__M)",
    transform: "translate(57.89 30.868)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI_logo_svg__N)",
    d: "M0 0h7.487v13.256H0z",
    transform: "rotate(-15.337 1.315 14.915)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#aI_logo_svg__y)",
    transform: "translate(50.084 .038)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(3.023 1.469)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(7.023 29.469)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(2.023 40.469)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(2.023 25.469)"
  }))));
};
export default SvgAILogo;